import React, {
  ChangeEventHandler,
  useContext,
  useEffect,
  useState,
} from "react";
import { Dropdown, Form, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { saveEnrollment } from "../../../fetch/enrollment";
import { FormError } from "../../FormError";
import { Button } from "../../styles/Button.styled";
import {
  CreditCheckSection,
  EnrollmentFormCol,
  EnrollmentFormRow,
  EnrollmentStepFooter,
  EnrollmentStepWrapper,
} from "../../styles/Enrollment.styled";
import { RadioBox } from "./RadioBox";
// import { toast } from 'react-toastify'
import moment, { Moment } from "moment";
import Datetime from "react-datetime";
import { Address } from "../../../types";
import { EnrollmentContext } from "./enrollment";
import { ValidateAddress } from "./validate_address";
import { EnrollmentStepInfo } from "./StepInfo";
import { useNavigate } from "react-router-dom";
import { CheckboxItem } from "../../CheckboxItem";
import { pushToDataLayer } from "../../data";
import { CONSTELLATION_UTIL_MAPPING } from "../../../config";
const statesList = [
  { name: "Alabama", abbr: "AL" },
  { name: "Alaska", abbr: "AK" },
  { name: "Arizona", abbr: "AZ" },
  { name: "Arkansas", abbr: "AR" },
  { name: "California", abbr: "CA" },
  { name: "Colorado", abbr: "CO" },
  { name: "Connecticut", abbr: "CT" },
  { name: "Delaware", abbr: "DE" },
  { name: "Florida", abbr: "FL" },
  { name: "Georgia", abbr: "GA" },
  { name: "Hawaii", abbr: "HI" },
  { name: "Idaho", abbr: "ID" },
  { name: "Illinois", abbr: "IL" },
  { name: "Indiana", abbr: "IN" },
  { name: "Iowa", abbr: "IA" },
  { name: "Kansas", abbr: "KS" },
  { name: "Kentucky", abbr: "KY" },
  { name: "Louisiana", abbr: "LA" },
  { name: "Maine", abbr: "ME" },
  { name: "Maryland", abbr: "MD" },
  { name: "Massachusetts", abbr: "MA" },
  { name: "Michigan", abbr: "MI" },
  { name: "Minnesota", abbr: "MN" },
  { name: "Mississippi", abbr: "MS" },
  { name: "Missouri", abbr: "MO" },
  { name: "Montana", abbr: "MT" },
  { name: "Nebraska", abbr: "NE" },
  { name: "Nevada", abbr: "NV" },
  { name: "New Hampshire", abbr: "NH" },
  { name: "New Jersey", abbr: "NJ" },
  { name: "New Mexico", abbr: "NM" },
  { name: "New York", abbr: "NY" },
  { name: "North Carolina", abbr: "NC" },
  { name: "North Dakota", abbr: "ND" },
  { name: "Ohio", abbr: "OH" },
  { name: "Oklahoma", abbr: "OK" },
  { name: "Oregon", abbr: "OR" },
  { name: "Pennsylvania", abbr: "PA" },
  { name: "Rhode Island", abbr: "RI" },
  { name: "South Carolina", abbr: "SC" },
  { name: "South Dakota", abbr: "SD" },
  { name: "Tennessee", abbr: "TN" },
  { name: "Texas", abbr: "TX" },
  { name: "Utah", abbr: "UT" },
  { name: "Vermont", abbr: "VT" },
  { name: "Virginia", abbr: "VA" },
  { name: "Washington", abbr: "WA" },
  { name: "West Virginia", abbr: "WV" },
  { name: "Wisconsin", abbr: "WI" },
  { name: "Wyoming", abbr: "WY" },
];
interface Props {
  show: boolean;

  // handleClearSelectedProduct: Function;
  isSameBillingAddress: boolean;
  setIsSameBillingAddress: Function;
  handleChangeInput: ChangeEventHandler<HTMLInputElement>;
  inputValue: any;
  requiredFields: any;
  setRequiredFields: Function;
  billingState: { name: string; abbr: string } | undefined;
  setBillingState: Function;
  setInputValue: Function;
  startDate: Moment | undefined;
  serviceType: ServiceTypeOption | undefined;
  setServiceType: Function;
  setStartDate: Function;
  errorFields: any;
}

interface ServiceTypeOption {
  label: string;
  value: string;
  desc: string;
}

export const EnrollmentStepService: React.FC<Props> = ({
  show,

  isSameBillingAddress,
  setIsSameBillingAddress,
  handleChangeInput,
  inputValue,
  billingState,
  setBillingState,
  requiredFields,
  setRequiredFields,
  setInputValue,
  startDate,
  serviceType,
  setServiceType,
  setStartDate,
  errorFields,
}) => {
  const {
    serviceAddress,
    holidays,
    handleSetErrorModalContent,
    getHolidays,
    utility,
    selectedProduct,
    // changeServiceAddress, changeUtility
  } = useContext<any>(EnrollmentContext);

  const { t } = useTranslation("enrollment");
  const serviceTypeOptions = [
    {
      id: "service-moving",
      label: t("Moving/NewService"),
      value: "1",
      desc: t(
        "I am moving and establishing service under my name at this address."
      ),
    },
    {
      id: "service-switching-later",
      label: "Switching",
      value: "2",
      desc: t(
        "I am not moving. I want to switch to Constellation.com on a specific date."
      ),
    },
    // {
    //     id: 'service-switching-immediately',
    //     label: t('Switching (Immediately)'),
    //     value: '3',
    //     desc: t(
    //         'I am not moving. I want to switch to the new provider as soon as possible (1-3 days)'
    //     ),
    // },
  ];

  const [loading, setLoading] = useState(false);

  const [cookieAddress, setCookieAddress] = useState<Address | undefined>();

  useEffect(() => {
    let _address = localStorage.getItem("selectedAddress");
    if (!_address) return;
    setCookieAddress(JSON.parse(_address));
  }, []);
  useEffect(() => {
    if (!show) return;
    window.digitalData.page.pageInfo.pageName = "Funnel Step 1";
  }, [show]);
  const [pushedToDL, setPushedToDL] = useState(false);
  useEffect(() => {
    if (serviceAddress && serviceType && !pushedToDL) {
      setPushedToDL(true);
      pushToDataLayer({
        event: "enrollment_address_information",
        zip_code: serviceAddress[0].zipcode,
        city: serviceAddress[0].city,
        user_region: serviceAddress[0].state,
        provider:
          //@ts-ignore
          CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
          utility.utility_code,
        electricity_plan_rate: selectedProduct.price1000,
        electricity_plan_term: selectedProduct.contract_term,
        electricity_plan_name: selectedProduct.plan_name,
        electricity_plan_termination_fee: selectedProduct.cancel_fee,
        offer_code: localStorage.getItem("promoCode"),
        esiid:serviceAddress[0].esiid
      });
    }
  }, [serviceAddress, serviceType]);
  if (!show) return null;

  return (
    <EnrollmentStepWrapper>
      <>
        <h6 className="mt-2">Service Address *</h6>
        {serviceAddress.length > 0 && cookieAddress && (
          <h5 className="mt-2">{serviceAddress[0]?.label}</h5>
        )}
        {!cookieAddress && <ValidateAddress errorFields={errorFields} />}
        <EnrollmentFormRow>
          <EnrollmentFormCol full>
            <CheckboxItem
              label={t(
                "My billing address is the same as this service address"
              )}
              value={`${isSameBillingAddress}`}
              checked={isSameBillingAddress}
              handleClick={() => {
                let newRequiredFields = Object.assign({}, requiredFields);
                if (isSameBillingAddress) {
                  newRequiredFields["billing_address"] = { type: "text" };
                  newRequiredFields["billing_city"] = { type: "text" };
                  newRequiredFields["billing_state"] = { type: "select" };
                  newRequiredFields["billing_zipcode"] = { type: "text" };
                } else {
                  if (newRequiredFields["billing_address"])
                    delete newRequiredFields["billing_address"];
                  if (newRequiredFields["billing_city"])
                    delete newRequiredFields["billing_city"];
                  if (newRequiredFields["billing_state"])
                    delete newRequiredFields["billing_state"];
                  if (newRequiredFields["billing_zipcode"])
                    delete newRequiredFields["billing_zipcode"];
                }
                setRequiredFields(newRequiredFields);
                setIsSameBillingAddress(!isSameBillingAddress);
              }}
              onlyread={false}
              disabled={loading}
              id="is-same-address"
            />
          </EnrollmentFormCol>
        </EnrollmentFormRow>
        {!isSameBillingAddress && (
          <div>
            <EnrollmentFormRow>
              <EnrollmentFormCol>
                <Form.Group
                  className={errorFields["billing_address"] ? "error" : ""}
                >
                  <Form.Label>{t("Billing Address Line 1")} *</Form.Label>
                  <Form.Control
                    type="text"
                    name="billing_address"
                    placeholder=""
                    maxLength={200}
                    value={inputValue.billing_address.value}
                    onChange={handleChangeInput}
                    disabled={loading}
                  />
                </Form.Group>
                <FormError message={errorFields["billing_address"]} />
              </EnrollmentFormCol>
              <EnrollmentFormCol>
                <Form.Group
                  className={errorFields["billing_address2"] ? "error" : ""}
                >
                  <Form.Label>{t("Billing Address Line 2")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="billing_address2"
                    placeholder=""
                    maxLength={100}
                    value={inputValue.billing_address2.value}
                    onChange={handleChangeInput}
                    disabled={loading}
                  />
                </Form.Group>
                <FormError message={errorFields["billing_address2"]} />
              </EnrollmentFormCol>
              <EnrollmentFormCol>
                <Form.Group
                  className={errorFields["billing_city"] ? "error" : ""}
                >
                  <Form.Label>{t("City")} *</Form.Label>
                  <Form.Control
                    type="text"
                    name="billing_city"
                    placeholder=""
                    maxLength={50}
                    value={inputValue.billing_city.value}
                    onChange={handleChangeInput}
                    disabled={loading}
                  />
                </Form.Group>
                <FormError message={errorFields["billing_city"]} />
              </EnrollmentFormCol>
              <EnrollmentFormCol>
                <Form.Group
                  className={errorFields["billingState"] ? "error" : ""}
                >
                  <Form.Label>{t("State")} *</Form.Label>
                  <Dropdown className="plans-filter-dd">
                    <Dropdown.Toggle
                      disabled={loading}
                      variant="outline-secondary"
                    >
                      {billingState ? billingState.name : "State..."}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {statesList.map((val, idx) => (
                        <Dropdown.Item
                          eventKey={val.abbr}
                          key={idx}
                          onClick={() => {
                            setBillingState(val);
                            let newInputValue = Object.assign({}, inputValue);
                            newInputValue.billing_state.value = val.abbr;
                            setInputValue(newInputValue);
                          }}
                          active={inputValue.billing_state.value === val.abbr}
                        >
                          {val.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <FormError message={errorFields["billingState"]} />
              </EnrollmentFormCol>
              <EnrollmentFormCol>
                <Form.Group
                  className={errorFields["billing_zipcode"] ? "error" : ""}
                >
                  <Form.Label>{t("Zipcode")} *</Form.Label>
                  <Form.Control
                    type="text"
                    name="billing_zipcode"
                    placeholder=""
                    maxLength={5}
                    value={inputValue.billing_zipcode.value}
                    onChange={handleChangeInput}
                    disabled={loading}
                  />
                </Form.Group>
                <FormError message={errorFields["billing_zipcode"]} />
              </EnrollmentFormCol>
            </EnrollmentFormRow>
          </div>
        )}
        {serviceAddress && serviceAddress[0] && (
          <>
            <EnrollmentFormRow>
              <EnrollmentFormCol full>
                <Form.Group
                  className={errorFields["serviceType"] ? "error" : ""}
                >
                  <RadioBox
                    title={`${t("Why do you need this service?")} *`}
                    options={serviceTypeOptions}
                    select={serviceType}
                    handleSelect={(val: any) => {
                      setServiceType(val);
                      getHolidays(val);
                    }}
                  />
                  <FormError message={errorFields["serviceType"]} />
                </Form.Group>
              </EnrollmentFormCol>
            </EnrollmentFormRow>
            {serviceType && serviceType.value !== "3" && (
              <>
                <EnrollmentFormRow>
                  <EnrollmentFormCol>
                    <Form.Group
                      className={errorFields["startDate"] ? "error" : ""}
                    >
                      <Form.Label>{t("Select Date")} *</Form.Label>
                      <Datetime
                        value={startDate}
                        onChange={(date: any) => {
                          setStartDate(date);
                          // setStep(2);
                        }}
                        dateFormat="MM/DD/YYYY"
                        timeFormat={false}
                        closeOnSelect={true}
                        inputProps={{
                          placeholder: t("MM/DD/YYYY"),
                          id: "select-start-date",
                          readOnly: true,
                        }}
                        isValidDate={(currentDate) => {
                          if (holidays) {
                            if (
                              currentDate.isBefore(
                                moment().format("YYYY-MM-DD")
                              ) ||
                              currentDate.isAfter(
                                moment(holidays.end_date, "YYYY-MM-DD")
                              )
                            )
                              return false;
                            const blackoutDate =
                              holidays?.blackout_dates?.filter(
                                (val: string) =>
                                  val.indexOf(
                                    moment(currentDate).format("YYYY-MM-DD")
                                  ) >= 0
                              );
                            if (blackoutDate?.length > 0) return false;
                            if (!holidays?.rep_service_type?.AllowedDates) {
                              return true;
                            }
                            const allowedDates =
                              holidays?.rep_service_type?.AllowedDates?.filter(
                                (val: string) =>
                                  val.indexOf(
                                    moment(currentDate).format("YYYY-MM-DD")
                                  ) >= 0
                              ) || [];
                            if (allowedDates?.length > 0) return true;
                            return false;
                          }
                          return true;
                        }}
                      />
                    </Form.Group>
                    <FormError message={errorFields["startDate"]} />
                  </EnrollmentFormCol>
                </EnrollmentFormRow>
                <p style={{ marginTop: -20, fontSize: 14, color: "#666" }}>
                  It may take 24 - 48 hours from your service request date for
                  services to be connected.
                </p>
              </>
            )}
            {/* {serviceType && serviceType.value !== "3" && startDate && (
            
          )} */}
          </>
        )}
      </>
    </EnrollmentStepWrapper>
  );
};
